/**
    this.dialog.open(PrinterSelectDialog, {
        data: {
          PrinterID: '... default printer selection ...',
          ConfirmButtonText: 'PRINT',
          Title: 'Printer',
          NumberOfCopies: {
            Label: '# of Copies',
            Max: 20
          }
        }
      }).afterClosed().subscribe((result: { Printer: string, NumberOfCopies: number }) => {
        if (!result.Printer) return;
        ... print result.NumberOfCopies to result.Printer.id ...

      })
    );
 */

import { Component, AfterViewInit, ViewChild, ElementRef, TemplateRef, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { AlertDialog } from './../alert-dialog/alert-dialog.component';
import { AppConfig } from 'src/app/app-config.service';
import { IPrinter } from 'src/app/services/wms.service';

export interface IPrintCopies { Label: string, Max?: number };

@Component({
  selector: 'app-printer-selector',
  templateUrl: './printer-selector.component.html',
  styleUrls: ['./printer-selector.component.css']
})
export class PrinterSelectDialog implements AfterViewInit {
  settings = AppConfig.settings;
  @ViewChild('printerSelector') private printerSelector?: ElementRef;
  @ViewChild('invalidPrinterDialog') invalidPrinterDialog?: TemplateRef<any>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      PrinterID: string | null,
      ConfirmButtonText: string | null,
      Title: string | null,
      message?: string | null,
      NumberOfCopies?: IPrintCopies
    },
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<PrinterSelectDialog>,
  ) {
    this.data ||= { PrinterID: null, ConfirmButtonText: null, Title: null };
    this.data.ConfirmButtonText ||= 'PRINT';
    this.data.Title ||= 'Printer';
    if (this.data.PrinterID) this.printerID = this.data.PrinterID;
  }

  ngAfterViewInit(): void {
    this.dialogRef.updatePosition({ top: '0' });
    this.focus();
  }
  focus() {
    setTimeout(() => {
      this.printerSelector?.nativeElement.focus();
    }, 100);
  }

  // private _printerID: string | null = null;
  // @Input()
  // get printerID() { return this._printerID; }
  // set printerID(value) { this._printerID = value; }
  // @Output()
  // printerIDChange = new EventEmitter<string | null>();
  public printerID: string | null = null;
  public printQty: number = 1;

  selectPrinterScan() {
    if (this.printerID) this.selectPrinter();
  }

  selectPrinter() {
    // no printer specified
    if (!this.printerID) {
      // confirm no printing
      const dialogRef = this.dialog.open(ConfirmationDialog, {
        data: {
          message: "Skip printing?",
          confirmText: 'Yes, skip',
          cancelText: 'No, wait',
        }
      });
      dialogRef.afterClosed().subscribe((do_skip: boolean) => {
        if (do_skip) {
          // Skip printing
          this.dialogRef.close(null);
        } else {
          // Resume printer selection
          this.focus();
          return;
        }
      })
    }

    // printer was selected
    else {
      // validate printer ID selection
      let printer: IPrinter | undefined = AppConfig.settings.WarehousePrinters.find(p => p.id == this.printerID?.toString().trim());

      if (printer) {
        // valid printer
        this.dialogRef.close({ Printer: printer, NumberOfCopies: this.printQty });
      } else {
        // invalid printer
        const dialogRef = this.dialog.open(AlertDialog, {
          data: {
            message: `"${this.printerID}" is not a valid printer`
          }
        })
      }
    }
  }

  cancel() {
    this.dialogRef.close();
  }
}
